<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_title_sample_set') || '样品需求填报'"
      visible
      direction="rtl"
      :size="1000"
      @close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          @close="close"
          @reload="$emit('reload')"
          :amzPurchaseDetailCode="amzPurchaseDetailCode"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('btn_set') || '填报' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzPurchaseDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
